import React, { memo } from 'react';
import List from 'components/UI/List';
import Button from 'components/UI/Button';
import Markup from 'components/Markup';
import LinkTiles from './LinkTiles';
import { useLang, useTrans } from 'utils/localisation';
import * as styles from './Content.module.scss';

function Content({
  description,
  experience,
  linkList,
  doubleList,
  linkTitle: customLinkTitle,
  link,
  target,
}) {
  const t = useTrans(['common']);
  const lang = useLang();
  const shouldShowLinkTiles = linkList?.length > 0;
  const defaultLinkTitle = lang === 'uk' ? t('learnMore') : t('seeMore');

  return (
    <>
      {description && (
        <Markup tag="p" className={styles.contentSubtitle}>
          {description}
        </Markup>
      )}
      {experience && (
        <div className={styles.listWrapper}>
          {experience.title && <p className={styles.experienceTitle}>{experience.title}</p>}
          <List
            className={styles.list}
            itemTag={experience?.listItemTag}
            items={experience.list}
            size="md"
            theme="smallMarginChecked"
          />
          {experience.text && <p className={styles.experienceText}>{experience.text}</p>}
        </div>
      )}
      {shouldShowLinkTiles && <LinkTiles links={linkList} />}
      {doubleList && (
        <List
          className={styles.doubleList}
          items={doubleList}
          size="md"
          theme="smallMarginChecked"
        />
      )}
      {link && (
        <Button tag="a" href={link} target={target} className={styles.link} fullWidthMobile>
          {customLinkTitle ?? defaultLinkTitle}
        </Button>
      )}
    </>
  );
}

export default memo(Content);
